import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Subscription } from 'rxjs';
import { ServiciosConcertado } from '../../models/api';
import { Subespecialidade } from '../../models/api';
import { AppState, SearchEngineType } from '../../models/state';
import { StateService } from '../../services/state.service';

interface TreeNode {
  isMainBranch: boolean;
  name: string;
  observations: string;
  children?: TreeNode[];
}

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit, OnDestroy {
  treeControl = new NestedTreeControl<TreeNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<TreeNode>();
  state: Partial<AppState>;
  subs: Subscription;

  @Input() inputData: ServiciosConcertado[];
  @Input() inputData1: Subespecialidade[];
  @Input() inputType: SearchEngineType;

  constructor(
    private stateService: StateService
  ) {
    this.subs = new Subscription();
    this.state = this.stateService.getStateValue();
    this.inputType = this.state.searchEngineType || 'medical-center';
  }

  ngOnInit(): void {
    this.subs.add(
      this.stateService.getState().subscribe(state => {
        this.state = state;
        this.dataSource.data = this.treeNodeBuilder();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0 || (node.observations && this.state?.tabIndex === 0);

  treeNodeBuilder(): TreeNode[] {
    let treeNode = [];

    switch (this.inputType) {
      case 'medical-center':
        treeNode = this.specialistTreeNodeBuilder();
        break;
      case 'diagnostic-test':
        treeNode = this.diagnosticTestTreeNodeBuilder();
        break;
      case 'additional-services':
        treeNode = this.additionalServicesTreeNodeBuilder();
        break;
      case 'emergency-center':
        treeNode = this.specialistTreeNodeBuilder();
        break;
      default:
        break;
    }
    return treeNode;
  }

  private diagnosticTestTreeNodeBuilder() {
    const treeNode = [];

    this.inputData?.forEach(data => {
      const temp = {
        isMainBranch: true,
        name: `<div class="flex"> - ${data.nombreEspecialidad} ${data.videoconsulta ? `<span class="mapfre-ml-s flex">
        <img src="assets/icons/video_consultation.svg" alt="">
        <div class="mapfre-ml-xs dark"> Videoconsulta disponible</div>
      </span>` : ''}</div>`,
        videoconsulta: data.videoconsulta,
        observations: data.observaciones,
        children: [
          {
            name: 'Actos médicos',
            children: data.actosMedicos.map(e => ({
              name: e.descripcionActoMedico,
              children: e.regionesAnatomicas
                ?.filter(ele => Object.keys(ele).length > 0)
                ?.map(p => ({
                  name: `- ${p.descripcion}`
                }))
            }))
          }
        ]

      };

      temp.children = temp.children?.filter(ele => ele.children?.length > 0);
      treeNode.push(temp);
    });
    return treeNode;
  }

  private specialistTreeNodeBuilder() {
    const treeNode = [];

    this.inputData?.forEach(data => {
      const temp = {
        isMainBranch: true,
        name: `<div class="flex"> - ${data.nombreEspecialidad} ${data.videoconsulta ? `<span class="mapfre-ml-s flex">
        <img src="assets/icons/video_consultation.svg" alt="">
        <div class="mapfre-ml-xs dark"> Videoconsulta disponible</div>
      </span>` : ''}</div>`,
        videoconsulta: data.videoconsulta,
        observations: data.observaciones,
        children: [
          {
            name: 'Especialistas',
            children: data.profesionalesSanitarios?.map(e => ({
              name: `<div class="flex"> - ${e.nombreProfesionalSanitario} ${e.videoconsulta ? `<span class="mapfre-ml-s flex">
                <img src="assets/icons/video_consultation.svg" alt="">
                <div class="mapfre-ml-xs dark"> Videoconsulta disponible</div>
              </span>` : ''}</div>`
            }))
          },
          {
            name: 'Áreas de capacitación',
            children: data.subespecialidades.map(e => ({
              name: e.descripcionSubespecialidad,
              children: e.profesionalesSanitarios
                ?.filter(ele => Object.keys(ele).length > 0)
                ?.map(p => ({
                  name: `- ${p.nombreProfesionalSanitario}`
                }))
            }))
          }
        ]

      };

      temp.children = temp.children?.filter(ele => ele.children?.length > 0);

      treeNode.push(temp);
    });
    return treeNode;
  }
   private additionalServicesTreeNodeBuilder() {
    const treeNode = [];

    this.inputData[0].subespecialidades?.forEach(data => {
      let temp = {
        name: `<div class="flex"> - ${data?.descripcionSubespecialidad} </div>`,
      };

      if(data?.profesionalesSanitarios[0]?.codigoProfesionalSanitario) {
        temp['children'] = data?.profesionalesSanitarios.map(e => ({
          name: e.nombreProfesionalSanitario,
        }))
      }


      treeNode.push(temp);
    });
    return treeNode;
   }

}
